import { type JSX } from 'react';
import useResizeObserver from 'use-resize-observer';

import { area } from './ChartGrid.sty.js';
import { Grid, GridProps } from '../../../../layouts/grid/Grid.js';


/**
 * @internal
 */
export interface ChartGridAreaProps extends Omit<GridProps<'div'>, 'children'> {
  gridArea: string;
  className?: string;
  children: (props: {
    availableWidth: number;
    availableHeight: number;
  }) => JSX.Element;
}

/**
 * A grid area in the that automatically adjusts its size to fit its container.
 * @internal
 */
export const ChartGridArea = ({
  gridArea,
  children,
  ...rest
}: ChartGridAreaProps) => {
  const { width, height, ref } = useResizeObserver<HTMLDivElement>();

  return (
    <Grid<'div'>
      ref={ref}
      gridItem
      className={area}
      justifyContent="center"
      gridArea={gridArea}
      {...rest}
    >
      {children({
        availableWidth: width ?? 0,
        availableHeight: height ?? 0,
      })}
    </Grid>
  );
};
